module.exports = __webpack_public_path__ + "img/pms.ab2defc8.png";